<!-- OFFERS SECTION -->
<ng-container *ngIf="offers && offers.length > 0">
  <div class="d-flex flex-column offers">
    <ng-container *ngFor="let o of offers">
      <lib-provider-offers-offer [offer]="o"
                                 [animalId]="animalId"
                                 [showMore]="showMoreBtn">
      </lib-provider-offers-offer>
    </ng-container>
  </div>
</ng-container>
<!-- END OF OFFERS SECTION -->
